import React from "react";
import IPage from "../../interfaces/page"
import ClientUpdateComponent from "../../components/ClientUpdate/ClientUpdate.component";

const ClientUpdatePage: React.FunctionComponent<IPage> = (props: IPage) => {
  return <ClientUpdateComponent></ClientUpdateComponent>;
};

export default ClientUpdatePage;
